import { Svg, Circle } from 'react-native-svg';

export const HamburgerIcon = () => {
	return (
		<Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			<Circle cx="6.03918" cy="12.0392" r="2.03918" fill="#2A3243" />
			<Circle cx="12.0011" cy="12.0392" r="2.03918" fill="#2A3243" />
			<Circle cx="17.9611" cy="12.0392" r="2.03918" fill="#2A3243" />
		</Svg>
	);
};
